import { useTranslation } from 'react-i18next';
import type { TourDefinition } from '@klonup/design-system';
import { createTaskSteps } from './createTaskSteps';

/**
 * Tour "Crear una tarea" para Admin. Empieza con una intro centrada y reutiliza el tramo
 * compartido de crear-tarea (createTaskSteps) — el mismo flujo que enseña el tour del BM
 * dentro de bm-connection-detail. Mantener un único origen del tramo evita que diverjan (DRY).
 *
 * Sin `requiredPath`: las anclas (botón "Nueva tarea" y secciones del ConnectionTaskSplitPanel)
 * viven en la ruta dinámica `/connections/:id`. Se lanza desde el menú y se deshabilita fuera del
 * detalle de conexión (ver OrgLayout) — mismo patrón que admin-connection-detail / bm-connection-detail.
 */
export function useAdminCreateTaskTour(): TourDefinition {
  const { t } = useTranslation();
  return {
    id: 'admin-create-task',
    title: t('onboarding.admin_create_task.menuTitle'),
    description: t('onboarding.admin_create_task.menuDescription'),
    icon: '➕',
    steps: [
      {
        id: 'intro',
        // Sin target → modal centrado de introducción.
        title: t('onboarding.admin_create_task.steps.intro.title'),
        description: t('onboarding.admin_create_task.steps.intro.description'),
      },
      // Tramo "crear tarea" — compartido con el tour del BM (DRY, ver createTaskSteps).
      ...createTaskSteps(t, 'onboarding.admin_create_task.steps'),
    ],
  };
}
